import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/studio/utils";

const buttonVariants = cva(
  "studio-button whitespace-nowrap focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default:
          "studio-button-primary",
        charcoal:
          "studio-button-primary",
        warm:
          "studio-button-primary",
        outline:
          "",
        ghost: "studio-button-ghost",
        link: "studio-button-link",
        secondary:
          "studio-button-secondary",
        destructive:
          "studio-button-destructive",
      },
      size: {
        default: "",
        sm: "studio-button-sm",
        lg: "studio-button-lg",
        xl: "studio-button-xl",
        icon: "studio-button-icon",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        ref={ref}
        className={cn(buttonVariants({ variant, size, className }))}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
